import { Button, Checkbox, Col, Form, Input, Row } from "antd";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ImageUrl } from "../../config/helpers";
import { Post } from "../../config/api/post";
import { USER_AUTH } from "../../config/constants/api";
import { useDispatch } from "react-redux";
import { addUser } from "../../redux/slice/authSlice";
import swal from "sweetalert";
import socket from "../../config/socket";



const SignIn = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = (values) => {
    setLoading(true);
    let data = {
      email: values.email,
      password: values.password,
    };
    Post(USER_AUTH.login, data)
      .then((response) => {
        if(response?.status){
          if(response?.data?.isAdmin){
            setLoading(false);
            socket.emit("setupAdmin", response?.data?.user);
            dispatch(
              addUser({ user: response?.data?.user, token: response?.data?.token })
            );
            navigate("/");
          }
          else{
            setLoading(false);
            swal("Error",'Invalid Credentials!', 'error')
          }
        }
        // socket.emit("setupAdmin", response?.data?.user); 
      })
      .catch((err) => {
        let message = err?.response?.data?.message
          ? err?.response?.data?.message
          : err?.message;
        setLoading(false);
        console.log(":::;", err);
        if (message) swal("Oops!", message, "error");
      });
  };
  return (
    <Row
      justify="center"
      style={{
        backgroundImage: `url('${ImageUrl("login.png")}')`, // Setting background color to black with 90% opacity
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
      className="h-screen max-sm:pb-8"
      gutter={[16, 0]}
    >
      <Col xl={8} lg={7} md={6} sm={0} xs={0}  className="flex justify-center items-end max-md:hidden">
        <img src={ImageUrl("login-2.png")} alt="" />
      </Col>
      <Col xl={8} lg={10} md={12} sm={20} xs={20} className=" items-center flex w-full">
        <div
          className="flex flex-col justify-center items-center bg-white rounded-lg pt-4 pb-8 px-8 max-lg:px-2 w-full"
          style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
        >
          <img src={ImageUrl("logo.png")} width={140} alt="logo" />
          <h3 className="mt-4 font-tavi text-3xl text-black max-md:text-xl">
            Sign In
          </h3>
          <p className="capitalize font-euclid text-sm text-[#34324B] mb-8 max-md:text-xs text-center">
            Enter your credentials to Sign in to the platform
          </p>
          <Form
            form={form}
            name="normal_login"
            onFinish={onFinish}
            layout="vertical"
            className="w-full px-8 max-xl:px-2"
          >
            <Row justify="center" gutter={[16, 16]}>
              <Col md={24} sm={24} xs={24}>
                <Form.Item
                  name="email"
                  label="Email Address"
                  rules={[
                    {
                      required: true,
                      message: "Please input your email address!",
                    },
                  ]}
                >
                  <Input
                    placeholder="Email Address"
                    className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                    autoComplete={false}
                    type="email"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row justify="center">
              <Col md={24} sm={24} xs={24}>
                <Form.Item
                  name="password"
                  label="Password"
                  rules={[
                    {
                      required: true,
                      message: "Please input password!",
                    },
                  ]}
                >
                  <Input.Password
                    placeholder="Password"
                    className="h-12 text-sm font-euclid bg-gray-100 "
                    autoComplete={false}
                  />
                </Form.Item>
                <div className="flex justify-between md:mx-4">
                  <Form.Item
                    name="remember"
                    valuePropName="checked"
                    className="flex items-center"
                  >
                    <Checkbox>
                      <p className="text-sm text-black font-euclid max-xl:text-xs max-sm:text-[9px]">
                        Remember me
                      </p>
                    </Checkbox>
                  </Form.Item>
                  <Link
                    to="/forgotPassword"
                    className="text-sm font-semiboldfont-euclid text-[#0B7FC3] hover:text-[#0B7FC3] pt-2 max-xl:text-xs max-sm:text-[9px]"
                  >
                    Forgot Password?
                  </Link>
                </div>
              </Col>
            </Row>

            <Row justify="center">
              <Col md={12}>
                <Form.Item className="self-center text-center">
                  <Button
                    htmlType="submit"
                    className="bg-button hover:bg-white hover:border-customGold hover:border-2 font-urban font-bold text-black px-14 h-[50px] hover:text-customGold text-center text-sm"
                  >
                    {loading ? "LOADING..." : "Login"}
                  </Button>
                </Form.Item>
              </Col>
            </Row>

            {/* <Row justify="center">
              <Link
                to="/signIn"
                className="font-euclid text-black text-sm  font-normal mt-4 hover:text-black max-xl:text-xs max-sm:text-[10px]"
              >
                Don’t Have An Account?{" "}
                <Link
                  to="/register"
                  className="font-semibold  border-b-2 border-black"
                >
                  SIGN UP
                </Link>
              </Link>
            </Row> */}
          </Form>
        </div>
      </Col>
      <Col xl={8} lg={7} md={6} sm={0} xs={0} className="flex justify-center items-end max-md:hidden">
        <img src={ImageUrl("login-1.png")} alt="" />
      </Col>
    </Row>
  );
};

export default SignIn;
